export default __webpack_public_path__ + "static/media/show-lock-icon.5743803f.svg";